import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./MobileOtpPage.css";
import "../LeadCaptureForm/HeroSection.css";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import callApi from "../../../../utility/apiCaller";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { login } from "../../../../store/app/appReducer";
import OTPInput from "react-otp-input";
import moment from "moment";
import { setInternalLead } from "../../../../store/app/aaSlice";
import getStateFromPincode from "../../Utils/stateMapperfnction";

const MobileOtpPage = ({
  isFormStarted,
  setIsFormStarted,
  currentStep,
  setCurrentStep,
  formData,
  setFormData
}) => {
  // --- STATE VARIABLES ---
  const [selectedAmount, setSelectedAmount] = useState('₹50K');
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [pincode, setPincode] = useState("");

  const [isMobileValid, setIsMobileValid] = useState(true);
  const [source, setSource] = useState("");
  const [utmSource, setUtmSource] = useState("");
  const [utmMedium, setUtmMedium] = useState("");
  const [affId, setAffId] = useState("");
  const [params] = useSearchParams();
  const ldId = params.get("ld_id") || "";
  const [errors, setErrors] = useState({});

  // ✅ FIX: Added the missing pre_lender_id variable
  const pre_lender_id = params.get("lender_id") || "";

  const [isConsentChecked, setIsConsentChecked] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isTncChecked, setIsTncChecked] = useState(true);
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const [leadId, setLeadId] = useState("");
  const [isEditMobileModalOpen, setIsEditMobileModalOpen] = useState(false);
  const [editMobileValue, setEditMobileValue] = useState("");
  const [editMobileError, setEditMobileError] = useState("");
  const RESEND_OTP_TIME = 30;
  const [resendCounter, setResendCounter] = useState(RESEND_OTP_TIME);
  const [canResendOtp, setCanResendOtp] = useState(false);
  const [otpTimerKey, setOtpTimerKey] = useState(0);
  const [ipAddress, setIpAddress] = useState("");

  // --- USE EFFECTS & TIMERS ---
  useEffect(() => {
    const fetchIp = async () => {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        setIpAddress(data?.ip);
      } catch (error) {
        console.log("Error fetching IP:", error);
      }
    };
    fetchIp();
  }, []);

  useEffect(() => {
    if (!isOtpGenerated) return;
    setResendCounter(RESEND_OTP_TIME);
    setCanResendOtp(false);
    const interval = setInterval(() => {
      setResendCounter((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResendOtp(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [isOtpGenerated, otpTimerKey]);

  useEffect(() => {
    if (params.get("source")) setSource(params.get("source"));
    if (params.get("utm_source")) setUtmSource(params.get("utm_source"));
    if (params.get("utm_medium")) setUtmMedium(params.get("utm_medium"));
    if (params.get("aff_id")) setAffId(params.get("aff_id"));
    if (params.get("lid")) setLeadId(params.get("lid"));
  }, [params]);

  // --- HELPERS ---
  const formatResendTime = (seconds) => {
    const clamped = Math.max(0, Number(seconds) || 0);
    const mm = String(Math.floor(clamped / 60)).padStart(2, "0");
    const ss = String(clamped % 60).padStart(2, "0");
    return `${mm}:${ss}`;
  };

  const getNumericAmount = (chipValue) => {
    switch (chipValue) {
      case "₹50K":
        return 50000;
      case "₹1L":
        return 100000;
      case "₹2L":
        return 200000;
      case "₹5L":
      case "₹5L+":
        return 500000; // Or 1000000 if ₹5L+ represents 10 Lakhs
      default:
        return 50000; // Fallback default
    }
  };

  const handleValidation = () => {
    if (!/^\d{10}$/.test(mobile) || mobile.length !== 10) {
      setIsMobileValid(false);
      return false;
    }
    setIsMobileValid(true);
    return true;
  };

  // --- LEGACY API LOGIC ---
  const generateLead = async (token) => {
    try {
      const res = await callApi(
        "v1/lead/dmi-lead",
        "post",
        {
          lead: {
            contact_phone: mobile,
            contact_name: name,
            pincode: pincode,
            steps_completed: 1,
            alliance_id: "gold-loan",
            aff_id: params.get("aff_id") || null,
            utm_source: params.get("utm_source") || null,
            source: params.get("source") || null,
            utm_medium: params.get("utm_medium") || null,
            utm_term: params.get("utm_term") || null,
            ads_name: params.get("ads_name") || null,
            ip_address: ipAddress,
            kyc_consent: isTncChecked,
            kyc_consent_datetime: new Date().toISOString(),
            amount_required: getNumericAmount(selectedAmount), // 👈 Mapped here for new users
          },
        },
        "core",
        token,
      );
      // ... rest of code

      if (!res || res.status !== "Success") return false;
      const finalLeadId = res?.data?.lead?._id;
      if (!finalLeadId) return false;

      dispatch(setInternalLead(finalLeadId));
      return finalLeadId;
    } catch (error) {
      toast.error("Something went wrong while generating lead.");
      return false;
    }
  };

  const fetchLeadData = async (token) => {
    try {
      if (leadId) return { hasLead: false, hasOffer: false };
      const startDate = moment().subtract(1, "months").startOf("day").toISOString();
      const endDate = moment().endOf("day").toISOString();

      const response = await callApi(
        "v1/lead/list",
        "post",
        { filters: { contact_phone: mobile, created_at: { $gte: startDate, $lte: endDate } } },
        "core",
      );

      const sortedLeads = (response?.data?.leadList || []).sort(
        (a, b) => new Date(b.updatedAt || b.createdAt) - new Date(a.updatedAt || a.createdAt),
      );
      const lead = sortedLeads[0];

      if (lead) {
        return { hasLead: true, hasOffer: false, leadId: lead._id };
      } else {
        const newLeadId = await generateLead(token);
        return { hasLead: false, hasOffer: false, leadId: newLeadId };
      }
    } catch (error) {
      return { hasLead: false, hasOffer: false, leadId: null };
    }
  };

  // --- SUBMIT: HERO TO OTP ---
  const handleHeroSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim() || name.trim().length < 2) {
      toast.error("Please enter a valid name.");
      return;
    }
    if (!handleValidation()) {
      toast.error("Please enter a valid 10-digit mobile number.");
      return;
    }
    if (!/^\d{6}$/.test(pincode)) {
      toast.error("Please enter a valid 6-digit pincode.");
      return;
    }
    if (!isConsentChecked) {
      toast.error("Please agree to the Terms and Conditions.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        { contact_phone: mobile, kyc_consent: isConsentChecked },
        "messaging",
      );

      if (response.status === "Success") {
        setUserClickData({
          event_name: `otp-send-for-gold-loan-v2`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_medium: utmMedium || "",
        });

        if (typeof setFormData === "function") {
          setFormData((prev) => ({
            ...prev,
            name: name,
            fullName: name,
            mobile: mobile,
            pincode: pincode,
            amount_required: selectedAmount,
            stepDone: 3,
          }));
        }

        localStorage.setItem("user_name", name);
        setIsOtpGenerated(true);
        setIsFormStarted();
        setOtpTimerKey((prev) => prev + 1);
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while sending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (!canResendOtp) return;
    try {
      setIsLoading(true);
      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        { contact_phone: mobile, kyc_consent: isConsentChecked, kyc_consent_datetime: new Date().toISOString() },
        "messaging",
      );
      if (response.status === "Success") {
        setUserClickData({
          event_name: `resend-otp-for-gold-loan-v2`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_medium: utmMedium || "",
        });
        setOtpTimerKey((prev) => prev + 1);
      } else {
        toast.error("Failed to resend OTP.");
      }
    } catch (error) {
      toast.error("An error occurred while resending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  // --- SUBMIT: VERIFY OTP & PUSH LEAD ---
  const handleOtpSubmit = async () => {
    if (otp.length !== 4) {
      toast.error("Please enter a valid 4-digit OTP.");
      return;
    }

    try {
      setIsLoading(true);
      const otpResponse = await callApi(
        "v1/sms/validate-otp",
        "post",
        { contact_phone: mobile, otp },
        "messaging",
      );

      if (otpResponse.status === "Success") {

        // ✅ EVENT TRACKING FIX
        setUserClickData({
          event_name: `verify-otp-gold-loan-v2`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_source: utmSource || "",
          utm_medium: utmMedium || "",
        });

        const leadData = await fetchLeadData(otpResponse?.data.token);
        const freshToken = otpResponse.data.token;

        dispatch(login({ ...otpResponse.data.customer, token: freshToken }));
        localStorage.setItem("mobile", mobile);

        // ✅ CORE LOGIC: Save lead data (Without custom update logic)
        const leadResponse = await callApi(
          "v1/lead/lead-from-phone",
          "post",
          {
            phone: mobile,
            website_kyc_consent: isTncChecked,
            website_kyc_consent_datetime: new Date().toISOString(),
            kyc_consent: isTncChecked,
            kyc_consent_datetime: new Date().toISOString(),
            utm_source: utmSource,
            otp_page: "gold-loan-v2",
            ip_address: ipAddress,
            amount_required: selectedAmount
          },
          "core",
          freshToken,
        );

        const fetchedLeadId = leadResponse?.data?.lead?._id;

        // 💥 INSTANT JUMP TO THANK YOU PAGE 💥
        setCurrentStep(2);

        if (fetchedLeadId) {

          // ✅ CORE LOGIC: Restored exact PHP campaign logic
          try {
            fetch(
              "https://campaigns.digitmoney.in/api/offercheck/requestjson.php?case=insert_digit_money_data",
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  api_key: "fca6416db1074658d6b6823380d18f04",
                  mobile: mobile,
                  lead_id: fetchedLeadId,
                }),
              }
            ).catch(err => console.error("External campaign error:", err));
          } catch (e) {
            console.error("Error in external lead insert:", e);
          }

          // Remove the 'if' condition completely so everyone gets pushed!
          const lendersToPush = [
            { lender_id: "6ac73876ff51f5d7328d7ca1", lender_name: "Muthoot FinCorp" },
            { lender_id: "69a2c7ab1f6f4ddfd5577314", lender_name: "IIFL Finance" },
            { lender_id: "69ea0b864084a68bdadc40bd", lender_name: "Muthoot Finance" },
            { lender_id: "6abb59d6a3ee46254d954755", lender_name: "Oro Money" },
            { lender_id: "6aa03dd160f34db15292641e", lender_name: "Rupeek GL" },
            { lender_id: "6ac37efdf072975a2b2502a2", lender_name: "Capri Global" },
          ];

          if (lendersToPush.length > 0) {
            try {
              Promise.allSettled(
                lendersToPush.map((lender) =>
                  callApi(
                    "v1/lead/bulk-lead-push-by-leadId",
                    "post",
                    { leads: [{ lead_id: fetchedLeadId }], lender_name: lender.lender_name, lender_id: lender.lender_id },
                    "core",
                    freshToken,
                  )
                )
              );
            } catch (err) {
              console.error("Bulk push error:", err);
            }
          }
        }
      } else {
        toast.error("Invalid OTP. Please try again.");
      }
    } catch (otpError) {
      console.error("Error occurred while verifying OTP:", otpError);
    } finally {
      setIsLoading(false);
    }
  };

  // --- UI RENDER ---
  return (
    <>
      {!isOtpGenerated ? (
        // 🟢 STEP 1: YOUR NEW HERO UI
        <div className="hero-container">
          <div className="hero-logo-container">
            <img src={`${process.env.PUBLIC_URL}/assets/img/Group%20494.svg`} alt="DigitMoney" className="brand-logo-img" />
          </div>
          <div className="hero-text-content">
            <h1 className="hero-title">Gold Loan made simple.</h1>
            <p className="hero-subtitle">Check how much you may be eligible for.</p>
          </div>
          <div className="trust-badges-container">
            <img src={`${process.env.PUBLIC_URL}/assets/img/Group%20516.svg`} alt="Trust Badges" className="trust-badges-img" />
          </div>

          <form className="hero-form-card" onSubmit={handleHeroSubmit}>
            <p className="form-question">How much do you need?</p>
            <div className="amount-chips">
              {['₹50K', '₹1L', '₹2L', '₹5L', '₹5L+'].map((amt) => (
                <button
                  key={amt}
                  type="button"
                  className={`chip-btn ${selectedAmount === amt ? 'active' : ''}`}
                  onClick={() => setSelectedAmount(amt)}
                >
                  {amt}
                </button>
              ))}
            </div>

            <div className="custom-input-box">
              <label className="field-label">Full Name</label>
              <input
                type="text"
                placeholder="e.g. Priya Sharma"
                value={name}
                onChange={(e) => setName(e.target.value.replace(/[^A-Za-z\s]/g, ""))}
                required
              />
            </div>

            <div className="custom-input-box mobile-box">
              <img src="/assets/img/Group 372.svg" alt="We don't spam" className="floating-badge-svg" />
              <div className="mobile-flex-wrapper">
                <div className="flag-prefix">🇮🇳 <span>▾</span></div>
                <div className="input-content-col">
                  <label className="field-label">Mobile Number</label>
                  <input
                    type="tel"
                    maxLength="10"
                    placeholder="10-digit mobile number"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="custom-input-box">
              <label className="field-label">Pin code</label>
              <input
                type="text"
                maxLength="6"
                placeholder="6-digit postal code"
                value={pincode}
                onChange={(e) => setPincode(e.target.value.replace(/\D/g, ""))}
                required
              />
            </div>

            <label className="terms-checkbox">
              <input
                type="checkbox"
                checked={isConsentChecked}
                onChange={() => setIsConsentChecked(!isConsentChecked)}
                required
              />
              <span>
                By submitting this form, you have read and agree to the
                <a href="#"> Credit Report Terms of Use</a>,
                <a href="https://digitmoney.in/terms"> Terms of Use</a> &
                <a href="https://digitmoney.in/privacy-policy"> Privacy Policy</a> of DigitMoney & its
                <a href="https://digitmoney.in/lending-partners"> Lending Partners</a>
              </span>
            </label>

            <button type="submit" className="submit-svg-btn" disabled={isLoading}>
              <img src="/assets/img/Group 366.svg" alt="Check my gold loan options" />
            </button>
            <p className="secure-text">{isLoading ? "Processing..." : "Your details are secure"}</p>
          </form>

          <div className="disbursed-svg-wrapper">
            <img src="/assets/img/Group 565.svg" alt="200 Cr+ Gold Loan Disbursed" />
          </div>
        </div>

      ) : (

        // 🟡 STEP 2: YOUR NEW GOLDEN OTP UI
        <div className="golden-otp-wrapper">
          <div className="otp-golden-card">
            <h2 className="otp-title">Verify Your Mobile Number</h2>
            <p className="otp-subtitle">Your data is encrypted & safe</p>
            <br />
            <p className="otp-sent-text">
              OTP sent to +91 XXXXXX{mobile.slice(-4) || "XXXX"}
            </p>
            <br />

            <div className="otp-input-container">
              <OTPInput
                value={otp}
                onChange={(val) => setOtp(val)}
                numInputs={4}
                isInputNum={true}
                shouldAutoFocus={true}
                inputStyle="golden-box-input"
                containerStyle="golden-box-container"
                renderInput={(props) => <input {...props} />}
              />
            </div>

            <div className="otp-resend-wrapper">
              Didn't receive the OTP?{" "}
              <br />
              {canResendOtp ? (
                <button type="button" className="otp-resend-btn" onClick={handleResendOtp} disabled={isLoading}>
                  Resend OTP
                </button>
              ) : (
                <span className="otp-resend-timer">Resend in {formatResendTime(resendCounter)} Sec</span>
              )}
            </div>

            <button type="button" className="otp-verify-submit-btn" onClick={handleOtpSubmit} disabled={otp.length !== 4 || isLoading}>
              {isLoading ? "Verifying..." : "Verify OTP"}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileOtpPage;